import { Component, Input } from '@angular/core';
import { Session } from '@models/Sessions/Session';
import { AssetsPipe } from '@pipes/assets.pipe';

@Component({
  selector: 'app-session-details',
  templateUrl: './session-details.component.html',
  styleUrls: ['./session-details.component.scss'],
})
export class SessionDetailsComponent {
  @Input() session: Session;

  constructor(private assetsPipe: AssetsPipe) {}

  get thumbnailImage() {
    if (this.session) {
      return this.assetsPipe.transform(
        this.session.config.thumbnail_id ||
          'image/default_session_thumbnail.png',
      );
    }

    return this.assetsPipe.transform('image/default_session_thumbnail.png');
  }
}
